import React, {Component} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Tabs, Tab, Form, FormGroup, ControlLabel, FormControl, Button} from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { updateUser } from "../../../actions/UserActions";
import API from "../../../services/APIService";
import UserService from "../../../services/UserService";
import LoaderInline from "../../helpers/LoaderInline";
import InlineError from "../../messages/InlineError";
import UpdatePasswordForm from "../../forms/users/UpdatePasswordForm";
import NotificationForm from "../../forms/users/NotificationsForm";
import HandleError from "../../../services/HandleError";

class UserProfilePage extends Component {

    state = {
    	isLoading: false,
    	isSaving: false,
    	isUploading: false,
    	formData: {
    		first_name: this.props.userLoginData.user.first_name,
    		last_name: this.props.userLoginData.user.last_name,
    		email: this.props.userLoginData.user.email,
    		skype_name: this.props.userLoginData.user.skype_name,
    		cellular: this.props.userLoginData.user.cellular,
    	},
    	errors: {},
    	selectedFile: null
    };
	
	onChange = (e) => this.setState({ formData: { ...this.state.formData, [e.target.name]: e.target.value } });

	onUploadImage = () => {
		const { selectedFile } = this.state;
		if (selectedFile && selectedFile.name) {
			const formdata = new FormData();
			formdata.append("id", this.props.userLoginData.user.id);
			formdata.append("photo", selectedFile, selectedFile.name);
			this.setState({isUploading:true});
			new UserService(this, this.props.userLoginData.user.id, "change-image").store(formdata, true).then((res) => {
				this.props.dispatch(updateUser(res.data.user));
				this.setState({ isUploading: false, selectedFile:null, errors:{} });
				NotificationManager.success("Image uploaded.","Success!");
			}).catch((err) => {
				HandleError(err, this);
				this.setState({ isUploading: false, selectedFile:null});
			});
		}
	}
	
	onSubmitUserData = (e) => {
		e.preventDefault();
		this.setState({ isSaving: true, errors: {} });
		new UserService(this, this.props.userLoginData.user.id, "change-profile").store(this.state.formData).then((res) => {
			this.setState({ isSaving: false });
			this.props.dispatch(updateUser(res.data.user));
			NotificationManager.success("Profile updated.","Success!");
		}).catch((err) => {
			this.setState({ isSaving: false });
			HandleError(err, this);
		});
	}

	getTitle = () => {
		if (this.props.userLoginData.user && this.props.userLoginData.user.attributes && Array.isArray(this.props.userLoginData.user.attributes)) {
			const attributes = this.props.userLoginData.user.attributes;
			const title = attributes.find((item) => (item.name === "title"));
			return title ? title.value : "";
		}
		return null;
	}

	handleImagePicker = (e) => this.setState({ selectedFile: e.target.files[0] });

    staticUrl = API.getStaticUrl();
 
    render() {		
    	const { first_name, last_name, email, skype_name, cellular } = this.state.formData;
    	const { errors, isSaving, isUploading } = this.state;
    	return (
    		<div className="user-page">
    			<div className="container-fluid user-container">
    				<header>
    					<h1>Profile Setting</h1>
    				</header>
    				<Row className="user-card">
    					<Col md={3} sm={5} className="user-aside fadeInLoadUp">
    						<div className="card card-top-border">
    							<div className="user-image">
    								<img src={`${this.staticUrl}/uploads/${this.props.userLoginData.user.image || "defaultUserImage.png"}`} alt="user-avatar" />								
    							</div>
    							<h2 className="text-center user-name">{`${first_name} ${last_name}`}</h2>
    							<h3 className="text-center user-title" >{this.getTitle()}</h3>
    							<div className="user-details">
    								<div className="small-wrapper">
    									<hr />
    									<h4>About Me</h4>
    								</div>
    								<ul>
    									<li className="small-wrapper">
    										<h5>Skype</h5>
    										<p>{skype_name}</p>
    									</li>
    									<li className="small-wrapper">
    										<h5>Cellular</h5>
    										<p>{cellular}</p>
    									</li>
    								</ul>
    							</div>
    						</div>
    					</Col>
    					<Col md={7} sm={7} className="user-main fadeInLoadUp">
    						<div className="card card-top-border">
    							<Tabs defaultActiveKey={1} id="user-profile-tab-editor" className="card-tab" onSelect={this.handleSelect}>
    								<Tab eventKey={1} title="Profile">
    									<div className="settings-form">
    										<Form horizontal onSubmit={this.onSubmitUserData} >
    											<FormGroup controlId="imageController" validationState={errors.photo && "error"}>
    												<Col componentClass={ControlLabel} sm={4}> Image </Col>
    												<Col sm={8}>
    													<FormControl type="file" onChange={this.handleImagePicker} accept="image/*"/>
    													<label htmlFor="imageController" className="image-uploade-label">
    														<span className="image-uploader-bg" >
    															<b>{(this.state.selectedFile && this.state.selectedFile.name) ? this.state.selectedFile.name : "Choose Image"}</b>
    														</span>
    													</label>
    													{errors.photo && <InlineError text={errors.photo} />}
    													<Button onClick={this.onUploadImage} disabled={isUploading} bsStyle="primary" className="btn-block">{isUploading ? "Uploading..." : "Upload"}</Button>
    												</Col>
    											</FormGroup>
    											<FormGroup controlId="FirstNameController" validationState={errors.first_name && "error"}>
    												<Col componentClass={ControlLabel} sm={4}>First name</Col>
    												<Col sm={8}>
    													<FormControl type="text" defaultValue={first_name} name="first_name" onChange={this.onChange} />
    													{errors.first_name && <InlineError text={errors.first_name} />}
    												</Col>
    											</FormGroup>
    											<FormGroup controlId="LastNameController" validationState={errors.last_name && "error"}>
    												<Col componentClass={ControlLabel} sm={4}>Last name</Col>
    												<Col sm={8}>
    													<FormControl type="text" defaultValue={last_name} name="last_name" onChange={this.onChange} />
    													{errors.last_name && <InlineError text={errors.last_name} />}
    												</Col>
    											</FormGroup>
    											<FormGroup controlId="EmailController" validationState={errors.email && "error"}>
    												<Col componentClass={ControlLabel} sm={4}>Email</Col>
    												<Col sm={8}>
    													<FormControl type="email" defaultValue={email} name="email" onChange={this.onChange} disabled/>
    													{errors.email && <InlineError text={errors.email} />}
    												</Col>
    											</FormGroup>
    											<FormGroup controlId="SkypeNameController" validationState={errors.skype_name && "error"}>
    												<Col componentClass={ControlLabel} sm={4}>Skype name</Col>
    												<Col sm={8}>
    													<FormControl type="text" defaultValue={skype_name} name="skype_name" onChange={this.onChange} />
    													{errors.skype_name && <InlineError text={errors.skype_name} />}
    												</Col>
    											</FormGroup>
    											<FormGroup controlId="CellularController" validationState={errors.cellular && "error"}>
    												<Col componentClass={ControlLabel} sm={4}>Cellular</Col>
    												<Col sm={8}>
    													<FormControl type="text" defaultValue={cellular} name="cellular" onChange={this.onChange} />
    													{errors.cellular && <InlineError text={errors.cellular} />}
    												</Col>
    											</FormGroup>
    											<FormGroup>
    												<Col smOffset={4} sm={8}>
    													<Button type="submit" disabled={isSaving} bsStyle="primary" className="withIcon btn-crud">{isSaving?"Saving...":"Save"}</Button>
    													{isSaving && <LoaderInline width="30" height="30" color="#2196f3"/> }
    												</Col>
    											</FormGroup>
    										</Form>
    									</div>
    								</Tab>
    								<Tab eventKey={2} title="Security" >
    									<UpdatePasswordForm />
    								</Tab>
    								<Tab eventKey={3} title="Notifications" >
    									<NotificationForm />
    								</Tab>
    							</Tabs>
    						</div>
    					</Col>
    				</Row>
    			</div>
    		</div>
    	);
    }
}

const UserPageData = (state) => ({
	userLoginData: state.userLoginData,
});

UserProfilePage.propTypes = {
	userLoginData: PropTypes.shape({
		user: PropTypes.shape({
			id: PropTypes.string,
			first_name: PropTypes.string,
			last_name: PropTypes.string,
			email: PropTypes.string,
			skype_name: PropTypes.string,
			cellular: PropTypes.string,
			image: PropTypes.string,
			date_of_birth: PropTypes.string,
			attributes: PropTypes.array
		}).isRequired
	}).isRequired,
	dispatch: PropTypes.func.isRequired
};
export default connect(UserPageData)(withRouter(UserProfilePage));


// WEBPACK FOOTER //
// ./src/components/pages/users/UserProfilePage.js